<template>
	<div
		:class="containerClass"
		v-if="show">
		<div class="notification-indicator__header" @click="toggleLabel">
			<b-icon icon="exclamation-triangle-fill" style="width: 20px; height: 20px; margin-top: 1px"></b-icon>
			<div class="notification-indicator__header__label">{{ $t('attention-required') }}</div>
		</div>
		<ul class="notification-indicator__content list-bare">
			<li v-for="(message, i) in messages" :key="message.message_id" @click="goToMessage(message, i)">
				<strong>{{ $t('new-message') }}</strong> {{ $t('from-user', {user: message.user_displayname}) }}
			</li>
			<li v-for="(comment, i) in comments" :key="comment.comment_id" @click="goToComment(comment, i)">
				<strong>{{ $t('new-comment') }}</strong> {{ $t('from-user', {user: comment.user_displayname}) }}
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	data() {
		return {
			labelActive: false,
			messages: [],
			comments: []
		};
	},
	methods: {
		goToMessage(message, i) {
			this.$router.push(`/messages/list/${message.message_id}`);
			this.toggleLabel();
			this.messages.splice(i, 1);
		},
		goToComment(comment, i) {
			this.$router.push({ path: `/clinical/treatmentsession/${comment.treatmentsession_id}`, query: { opencomments: 1 }});
			this.toggleLabel();
			this.comments.splice(i, 1);
		},
		toggleLabel() {
			this.labelActive = !this.labelActive;
		},
		getNotifications() {
			if (this.$UserSession.getValue("authToken")) {
				this.$cfetch(`${this.$settings.APIBaseURL}/getnotifications`, {
					ignoreauthfailed: true
				})
				.then(json => {
					this.$emit('online');
					// Logged out while this request was in flight.
					if (!this.$UserSession.getValue("authToken")) {
						return;
					}
					if (json.status.toLowerCase() === "success") {
						this.messages = json.messages;
						this.comments = json.comments;
						this.$store.commit("setNotifications" , json.messages);
					}
				})
				.catch(error => {
					this.$emit('offline');
					this.$log.error.call(this, error);
				});	
			} else {
				this.unsubscribeFromNotifications();
			}
		},
		subscribeToNofications() {
			// Callers (tryAuth, login) can invoke this several times; keep exactly one timer running.
			this.unsubscribeFromNotifications();
			this.getNotifications();
			this.interval = setInterval(() => {
				this.getNotifications();
			}, 10 /* seconds */ * 1000)
		},
		unsubscribeFromNotifications() {
			if (this.interval) {
				clearInterval(this.interval);
				this.interval = null;
			}
			// Don't leave the previous user's notifications on screen after logout.
			this.messages = [];
			this.comments = [];
			this.labelActive = false;
			this.$store.commit("clearAllNotifications");
		}
	},
	beforeDestroy() {
		this.unsubscribeFromNotifications();
	},
	computed: {
		containerClass() {
			if (this.labelActive) {
				return "notification-indicator active";
			}
			return "notification-indicator";
		},
		show() {
			return this.messages.length || this.comments.length;
		}
	},
};
</script>
